"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartureDateMode = void 0;
var DepartureDateMode;
(function (DepartureDateMode) {
    DepartureDateMode["UTC"] = "UTC";
    DepartureDateMode["DEFAULT"] = "DEFAULT";
})(DepartureDateMode || (exports.DepartureDateMode = DepartureDateMode = {}));
//# sourceMappingURL=departure-date-mode.enum.js.map